import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../../../colorVars';
import { useWebsocketStore } from '../../../../../../stores/websocketStore/websocketProvider';
import { ChartWrapper } from '../../../../charts/d3/candlestickchart/newCandleChart/ChartWrapper';
import {
  determineBrokerage,
  determineCandleDuration,
} from '../../../../charts/d3/candlestickchart/newCandleChart/utils/initialValuesUtils';
import { DetailsSection } from '../detailsSection/DetailsSection';
import { AuxPanel } from './AuxPanel';
import style from './ChartTab.module.css';
import { OrdersAndQuickTradeContainer } from './ordersQuickTrade/OrdersAndQuickTradeContainer';

function ChartTab({ tradePlanId, tabProps }) {
  const { tradePlanStore } = useWebsocketStore();
  const tradePlan = tradePlanStore.tradePlans[tradePlanId];
  const initialValues = {
    symbol: tradePlan.symbol,
    dataSource: tradePlan.dataSource,
    brokerage: determineBrokerage(tradePlan),
    numberOfCandles: 30,
    timeUnit: 'MINUTES',
    candleDuration: determineCandleDuration(tradePlan),
    tradePlanId: tradePlan.id,
    size: 300,
    type: 'tradeplan',
  };

  return (
    <div
      className={style.container}
      style={{ borderColor: tradePlan.inPosition ? colors.green : colors.blue }}
    >
      <div className={style.topSection}>
        <div className={style.leftSection}>
          <ChartWrapper initialValues={initialValues} />
        </div>
        <div className={style.rightSection}>
          <OrdersAndQuickTradeContainer tradePlanId={tradePlanId} />
          {/* <QuickTradeModule tradePlanId={tradePlanId} /> */}
          <AuxPanel tradePlanId={tradePlanId} />
        </div>
      </div>
      <DetailsSection tabProps={tabProps} tradePlanId={tradePlanId} />
    </div>
  );
}

ChartTab.propTypes = {
  tradePlanId: PropTypes.string,
  tabProps: PropTypes.shape({
    tabList: PropTypes.object,
    addTab: PropTypes.func,
    removeTab: PropTypes.func,
    setLastOpenTab: PropTypes.func,
    lastOpenTab: PropTypes.number,
  }),
};

export default ChartTab;
